import styled from 'styled-components';

export const Box = styled.div`
    position: relative;
    border: 1px solid rgba(0, 0, 0, .1);
    background: ${props => props.isDark ? '#4D494A' : '#ffffff'};
`;

export const Input = styled.input`
    background: ${props => props.isDark ? '#4D494A' : '#ffffff'};
    width: 100%;
    padding: .7rem 1rem;
    border: 0px;
    color: ${props => props.isDark ? '#ffffff' : '#000000'};
    outline: none;

    ::-webkit-input-placeholder {
        color: ${props => props.isDark ? 'rgba(255, 255, 255, .5)' : 'grey'};
    }

    &:hover {
        box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.1);
    }

    &:focus {
        background-color: white;
        color: #000000;
        box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.1);
    }
`;

export const MenuWrapper = styled.div`
    width: 100%;
    z-index: 10;
    background: white;
    position: absolute;
    border: 1px solid rgba(202, 211, 228, 1.0);
    box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.1);
`;

export const MenuItem = styled.div`
    padding: 0.5rem 1rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background: ${props => !props.active ? 'white' : 'rgba(250, 250, 255, 1.0)' };

    &:hover {
        background: #F0F0F0;
        cursor: pointer;
    }
`;

export const DefaultFooterTitle = styled.div`
    color: #211E1E;
    padding-left: 1rem;
`;

export const DefaultFooterWrapper = styled.div`
    padding: .7rem 1rem;
    display: flex;
`;

export const StyledLink = styled.span`
      color: #211E1E;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
`;



// WEBPACK FOOTER //
// ./src/components/Search/Styled.js